import * as React from 'react';

const Uk16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M14.15 3.364q.23.162.407.38L10.37 6.62h-.96z" }), /* @__PURE__ */ React.createElement("path", { fill: "#1A237B", d: "M13 3H9.14v3.36l4.658-3.194A2 2 0 0 0 13 3" }), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M1.291 3.96a2 2 0 0 1 .345-.422L6.11 6.62h-.97z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M6.98 3H3c-.253 0-.495.047-.718.132L6.98 6.36zm7.924 1.386q.09.276.096.578V6.62h-3.32z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M7.41 3v4.21H1v1.78h6.41V13h1.3V8.99H15V7.21H8.71V3z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M1.118 4.322A2 2 0 0 0 1 5v1.62h3.44zM2.988 13a2 2 0 0 1-.515-.07L6.98 9.84V13z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M2.154 12.813a2 2 0 0 1-.492-.327L5.89 9.59h.97z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M1 9.59V11c0 .298.065.58.182.835L4.44 9.59zm12.618 3.313a2 2 0 0 1-.606.097H9.14V9.84z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M14.708 12.04a2 2 0 0 1-.345.424L10.16 9.59h.96z" }), /* @__PURE__ */ React.createElement("path", { fill: "#1A237B", d: "M15 11.036a2 2 0 0 1-.149.722L11.68 9.59H15z" }));
Uk16.Size = 16;
Uk16.Title = "Uk";

export { Uk16 as default };
